import { render, staticRenderFns } from "./Posnet.vue?vue&type=template&id=7f094044&scoped=true&"
import script from "./Posnet.vue?vue&type=script&lang=js&"
export * from "./Posnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f094044",
  null
  
)

export default component.exports